import React, { useState } from 'react';
import PublishStatusComponent from '../../components/PublishStatusComponent';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { Result } from '@peercolab/engine/esm';
import { Published } from '../../peer-colab-model/PetKey/Main/Model/1_0_Initial/Backoffice/Core/PathItems';

interface EditHealthCheckItemProps {
  name: string;
  translationKey: string;
  state: Published
  onBack: () => void;
  onSave: (name: string, translationKey: string) => void;
  onPublishTransition: (action: string) => Promise<Result<any>>;
}

const EditHealthCheckItem: React.FC<EditHealthCheckItemProps> = ({ state, onPublishTransition, name: initialName, translationKey: initialTranslationKey, onBack, onSave }) => {
  const [name, setName] = useState(initialName);

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <IconButton onClick={onBack} sx={{ mr: 2 }}>
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>Edit Health Check Item</Typography>
        </Box>
        <PublishStatusComponent
          status={state}
          onTransition={onPublishTransition}
        />
      </Box>
      <TextField
        label="Item Name"
        value={name}
        onChange={e => setName(e.target.value)}
        fullWidth
        sx={{ mb: 3 }}
      />
      <TextField
        label="Translation Key"
        value={initialTranslationKey}
        disabled
        fullWidth
        sx={{ mb: 3 }}
      />
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
        <Button variant="contained" color="primary" onClick={() => onSave(name, initialTranslationKey)}>Save</Button>
        <Button onClick={onBack}>Cancel</Button>
      </Box>
    </Box>
  );
};

export default EditHealthCheckItem;
